import { render, staticRenderFns } from "./CoozzyTicketIcon.vue?vue&type=template&id=cb4a6946&scoped=true"
import script from "./CoozzyTicketIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyTicketIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4a6946",
  null
  
)

export default component.exports